// @flow
import accountSyncActionKeys from './accountSyncActionKeys';
import accountSyncService from './accountSyncService';

// leaving these typed as 'any' because while they return promises, redux-promise-middleware
// doesn't actually document that behavior
const createAccount = (email: string, entityId: string, entityHash: string): any => ({
  type: accountSyncActionKeys.CREATE_ACCOUNT,
  payload: {
    data: { email, entityId, entityHash },
    promise: accountSyncService.createAccount(email, entityId, entityHash),
  },
});

const createAccountReset = (): any => ({
  type: accountSyncActionKeys.CREATE_ACCOUNT_RESET,
});

const linkAccounts = (leadsUserId: number, adsUserId: number, entityHash: string): any => ({
  type: accountSyncActionKeys.LINK_ACCOUNTS,
  payload: {
    data: { leadsUserId, adsUserId, entityHash },
    promise: accountSyncService.linkAccounts(leadsUserId, adsUserId, entityHash),
  },
  meta: { adsUserId },
});

const linkBusiness = (username: string, password: string) : any => ({
  type: accountSyncActionKeys.LINK_BUSINESS,
  payload: {
    data: { username, password },
    promise: accountSyncService.linkBusiness(username, password),
  },
});

export default {
  createAccount, createAccountReset, linkAccounts, linkBusiness,
};



// WEBPACK FOOTER //
// ./src/modules/sync/common/accountSyncActions.js